import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { Button } from '../components/Button';
import { CheckCircleIcon, ShareIcon, UsersIcon } from 'lucide-react';
export const BookingConfirmation = () => {
  const {
    eventId,
    tableId
  } = useParams();
  const navigate = useNavigate();
  // Mock data
  const booking = {
    id: 'b123',
    eventName: 'Summer Club Night',
    tableName: 'VIP Table',
    date: 'Saturday, 15 July 2023',
    time: '22:00 - 05:00',
    location: 'Club XYZ, Berlin',
    bookingCode: 'PRTX-8472'
  };
  const handleViewRequests = () => {
    navigate(`/guest-requests/${booking.id}`);
  };
  const handleViewBookings = () => {
    navigate('/bookings');
  };
  return <div className="bg-white min-h-screen pb-16" data-id="element-139">
      <Header title="Booking Confirmed" showNotifications={false} data-id="element-140" />
      <div className="p-4 flex flex-col items-center" data-id="element-141">
        <div className="mt-4 mb-6 text-center" data-id="element-142">
          <CheckCircleIcon className="h-16 w-16 text-gray-800 mx-auto mb-4" data-id="element-143" />
          <h1 className="text-xl font-bold text-gray-800 mb-2" data-id="element-144">
            Booking Confirmed!
          </h1>
          <p className="text-gray-600" data-id="element-145">
            Your table has been successfully booked.
          </p>
        </div>
        <div className="border border-dashed border-gray-300 rounded-lg p-4 w-full mb-6" data-id="element-146">
          <h2 className="font-medium text-gray-800 mb-3" data-id="element-147">Booking Details</h2>
          <div className="mb-1" data-id="element-148">
            <span className="text-gray-600" data-id="element-149">Event:</span>
            <span className="text-gray-800 ml-2 font-medium" data-id="element-150">
              {booking.eventName}
            </span>
          </div>
          <div className="mb-1" data-id="element-151">
            <span className="text-gray-600" data-id="element-152">Table:</span>
            <span className="text-gray-800 ml-2 font-medium" data-id="element-153">
              {booking.tableName}
            </span>
          </div>
          <div className="mb-1" data-id="element-154">
            <span className="text-gray-600" data-id="element-155">Date:</span>
            <span className="text-gray-800 ml-2" data-id="element-156">{booking.date}</span>
          </div>
          <div className="mb-1" data-id="element-157">
            <span className="text-gray-600" data-id="element-158">Time:</span>
            <span className="text-gray-800 ml-2" data-id="element-159">{booking.time}</span>
          </div>
          <div className="mb-1" data-id="element-160">
            <span className="text-gray-600" data-id="element-161">Location:</span>
            <span className="text-gray-800 ml-2" data-id="element-162">{booking.location}</span>
          </div>
          <div className="mt-3 pt-3 border-t border-gray-200" data-id="element-163">
            <span className="text-gray-600" data-id="element-164">Booking Code:</span>
            <span className="text-gray-800 ml-2 font-medium" data-id="element-165">
              {booking.bookingCode}
            </span>
          </div>
        </div>
        <div className="w-full mb-4" data-id="element-166">
          <Button variant="secondary" className="w-full mb-3" leftIcon={<ShareIcon className="h-4 w-4" data-id="element-168" />} data-id="element-167">
            Share Booking
          </Button>
          <Button variant="secondary" className="w-full" leftIcon={<UsersIcon className="h-4 w-4" data-id="element-170" />} onClick={handleViewRequests} data-id="element-169">
            View Guest Requests
          </Button>
        </div>
        <Button onClick={handleViewBookings} className="w-full" data-id="element-171">
          View My Bookings
        </Button>
      </div>
      <Navigation data-id="element-172" />
    </div>;
};